import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../component/common/Navbar";

const Business = () => {
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [businessName, setBusinessName] = React.useState('');
  const [businessType, setBusinessType] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [submissionStatus, setSubmissionStatus] = React.useState(null); // 'success', 'error', null

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionStatus(null); // Clear previous status

    const formData = {
      name,
      email,
      phone,
      businessName,
      businessType,
      message,
    };
    console.log('Submitting form data:', formData); // Log form data

    try {
      const response = await fetch('https://dashboard-api.playgg.in/landing-page/create/inquiry', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'App-version': '1.0', // Added App-version header
          'Session-Id': 'dsadsda', // Added Session-Id header
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmissionStatus('success');
        // Clear form fields
        setName('');
        setEmail('');
        setPhone('');
        setBusinessName('');
        setBusinessType('');
        setMessage('');
      } else {
        console.error('API Response not OK:', response.status, response.statusText);
        const errorData = await response.json().catch(() => ({ message: 'No error details provided' }));
        console.error('Error details:', JSON.stringify(errorData, null, 2)); // Stringify error data
        setSubmissionStatus('error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmissionStatus('error');
    }
  };

  return (
    <div className="min-h-screen text-white bg-black">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-20 md:pt-28 pb-16 md:pb-20 px-4 md:px-8 relative">
        {/* <div className="absolute inset-0 bg-gradient-to-b from-purple-900/20 to-transparent"></div> */}
        <div className="max-w-6xl mx-auto relative">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-4 md:mb-6 bg-gradient-to-r from-yellow-300 to-yellow-500 bg-clip-text text-transparent">
            PlayGG for Business
          </h1>
          <div className="mb-8 md:mb-12">
            <h2 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6 text-gray-200">
              Download the PlayGG Business App:
            </h2>
            <div className="flex flex-col sm:flex-row gap-4 md:gap-6">
              <a
                href="https://play.google.com/store/apps/details?id=com.playgg&hl=en_IN"
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 md:px-6 py-3 bg-gradient-to-r from-black to-yellow-500 rounded-lg hover:from-black hover:to-yellow-600 transition-all duration-300 flex items-center justify-center sm:justify-start gap-2 w-full sm:w-auto"
              >
                <span>Get it on Google Play</span>
                <svg
                  width="20px"
                  height="20px"
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>ionicons-v5_logos</title>
                  <path
                    d="M48,59.49v393a4.33,4.33,0,0,0,7.37,3.07L260,256,55.37,56.42A4.33,4.33,0,0,0,48,59.49Z"
                    fill="white"
                  />
                  <path
                    d="M345.8,174,89.22,32.64l-.16-.09c-4.42-2.4-8.62,3.58-5,7.06L285.19,231.93Z"
                    fill="white"
                  />
                  <path
                    d="M84.08,472.39c-3.64,3.48.56,9.46,5,7.06l.16-.09L345.8,338l-60.61-57.95Z"
                    fill="white"
                  />
                  <path
                    d="M449.38,231l-71.65-39.46L310.36,256l67.37,64.43L449.38,281C468.87,270.23,468.87,241.77,449.38,231Z"
                    fill="white"
                  />
                </svg>{" "}
              </a>
             
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-12 md:py-20 px-4 md:px-8 bg-black backdrop-blur-sm">
        <div className="max-w-6xl mx-auto">
          <div className="mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold mb-6 md:mb-8 text-center bg-gradient-to-r from-black to-yellow-500 bg-clip-text text-transparent px-4">
              Unlock the Power of Gaming with PlayGG
            </h2>
            <p className="text-gray-300 text-base md:text-lg max-w-3xl mx-auto text-center leading-relaxed px-4">
              Are you a gaming café or esports organizer looking to streamline
              your operations and attract more gamers? PlayGG is your all-in-one
              platform designed to help you manage bookings, host tournaments,
              and gain valuable customer insights—all from a single, easy-to-use
              dashboard.
            </p>
          </div>

          {/* Features Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mb-12 md:mb-20 px-4">
            {features.map((feature, index) => (
              <FeatureCard key={index} text={feature} />
            ))}
          </div>

          {/* Dashboard Features */}
          <div className="mb-12 md:mb-20 bg-black rounded-2xl p-4 md:p-8 backdrop-blur-sm mx-4">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6 md:mb-8 text-center bg-gradient-to-r from-black to-yellow-500 bg-clip-text text-transparent">
              PlayGG Business Dashboard
            </h2>
            <p className="text-gray-300 mb-6 md:mb-8 text-center max-w-3xl mx-auto text-sm md:text-base">
              Our powerful dashboard is designed to help gaming cafés and
              esports organizers run their operations efficiently. With just a
              few clicks, you can:
            </p>
            <ul className="grid sm:grid-cols-2 gap-4 text-gray-300 max-w-3xl mx-auto text-sm md:text-base">
              {dashboardFeatures.map((feature, index) => (
                <li
                  key={index}
                  className="flex items-start gap-3 p-3 md:p-4 rounded-lg bg-black"
                >
                  <svg
                    className="w-5 md:w-6 h-5 md:h-6 text-yellow-500 flex-shrink-0 mt-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Form */}
          <div className="max-w-3xl mx-auto bg-black rounded-2xl p-4 md:p-8 backdrop-blur-sm mx-4">
            <h2 className="text-2xl sm:text-3xl font-bold mb-4 md:mb-6 text-center bg-gradient-to-r from-black to-yellow-500 bg-clip-text text-transparent">
              Get Started with PlayGG
            </h2>
            <p className="text-gray-300 mb-6 md:mb-8 text-center text-sm md:text-base">
              Fill out the form below, and our team will get in touch with you
              shortly.
            </p>
            <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                <input
                  type="text"
                  placeholder="Name"
                  className="w-full bg-inherit rounded-lg p-3 md:p-4 border border-gray-600 focus:border-yellow-500 focus:ring-2 focus:ring-yellow-500/20 transition-all duration-300 text-sm md:text-base"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  type="email"
                  placeholder="Email"
                  className="w-full bg-inherit rounded-lg p-3 md:p-4 border border-gray-600 focus:border-yellow-500 focus:ring-2 focus:ring-yellow-500/20 transition-all duration-300 text-sm md:text-base"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  type="tel"
                  placeholder="Phone"
                  className="w-full bg-inherit rounded-lg p-3 md:p-4 border border-gray-600 focus:border-yellow-500 focus:ring-2 focus:ring-yellow-500/20 transition-all duration-300 text-sm md:text-base"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Business Name"
                  className="w-full bg-inherit rounded-lg p-3 md:p-4 border border-gray-600 focus:border-yellow-500 focus:ring-2 focus:ring-yellow-500/20 transition-all duration-300 text-sm md:text-base"
                  value={businessName}
                  onChange={(e) => setBusinessName(e.target.value)}
                />
                <select
                  className="w-full bg-inherit rounded-lg p-3 md:p-4 border border-gray-600 focus:border-yellow-500 focus:ring-2 focus:ring-yellow-500/20 transition-all duration-300 text-sm md:text-base"
                  value={businessType}
                  onChange={(e) => setBusinessType(e.target.value)}
                >
                  <option value="">Business Type</option>
                  <option value="cafe">Gaming Café</option>
                  <option value="esports">Esports Organizer</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <textarea
                placeholder="Message"
                rows="4"
                className="w-full bg-inherit rounded-lg p-3 md:p-4 border border-gray-600 focus:border-yellow-500 focus:ring-2 focus:ring-yellow-500/20 transition-all duration-300 text-sm md:text-base"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
              {submissionStatus === 'success' && (
                <p className="text-green-500 text-center">Inquiry submitted successfully!</p>
              )}
              {submissionStatus === 'error' && (
                <p className="text-red-500 text-center">Failed to submit inquiry. Please try again.</p>
              )}
              <div className="text-center">
                <button
                  type="submit"
                  className="w-full sm:w-auto px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r from-black to-yellow-500 rounded-lg hover:from-black hover:to-yellow-600 transition-all duration-300 transform hover:scale-105 text-sm md:text-base"
                >
                  Submit Inquiry
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

const FeatureCard = ({ text }) => {
  return (
    <div className="p-6 rounded-xl border border-gray-700 hover:border-purple-500 transition-all duration-300 bg-black backdrop-blur-sm group hover:transform hover:scale-105">
      <p className="text-gray-300 group-hover:text-white transition-colors">
        {text}
      </p>
    </div>
  );
};

const features = [
  "Automated Bookings – No more manual reservations; manage seats and availability seamlessly.",
  "Tournament Management – Easily set up and promote tournaments with real-time tracking.",
  "Customer Insights – Understand your players better with data-driven analytics.",
  "Secure Payments – Handle tournament fees and bookings without hassle.",
  "Marketing Support – Get more visibility and attract a larger gaming audience.",
];

const dashboardFeatures = [
  "Manage real-time seat availability and prevent overbooking",
  "Set up and automate tournament registrations",
  "Track revenue, customer trends, and engagement levels",
  "Offer discounts and loyalty rewards to frequent players",
];

export default Business;
